
import WpImage from '~/components/ui/img.vue';

export default {
  name: 'RecipeSummary',

  components: {
    WpImage,
  },

  props: {
    recipe: {
      type: Object,
      required: true,
    },
    loading: {
      type: String,
      default: 'lazy',
    },
  },

  methods: {
    toRecipe() {
      this.$router.push(
        this.localePath({
          name: 'recipe-slug',
          params: { slug: this.recipe.slug },
        })
      );
    },
  },
};
